
{
  "nav": {
    "home": "首頁",
    "explore": "探索",
    "about": "關於我們",
    "pricing": "價格方案",
    "submitListing": "提交列表",
    "login": "登入",
    "signup": "註冊"
  },
  "userMenu": {
    "profile": "個人資料",
    "myListings": "我的列表",
    "favorites": "我的收藏",
    "referFriend": "推薦朋友",
    "paymentPending": "付款待處理",
    "logout": "登出",
    "upgradeToPremium": "升級至高級方案",
    "addListing": "新增列表"
  },
  "navigation": {
    "home": "首頁",
    "explore": "探索",
    "about": "關於我們",
    "pricing": "價格方案",
    "login": "登入",
    "signup": "註冊",
    "admin": "管理員"
  },
  "buttons": {
    "loading": "載入中..."
  },
  "profile": {
    "title": "個人資料設定",
    "description": "管理您的帳戶設定和偏好",
    "completeTitle": "完成您的個人資料",
    "completeDescription": "請完成您的個人資料以繼續",
    "profileNotFound": "找不到個人資料",
    "tabs": {
      "profile": "個人資料",
      "security": "安全設定"
    },
    "loading": "載入個人資料中...",
    "completeAlert": "請完成您的個人資料以繼續使用平台。",
    "form": {
      "title": "個人資料",
      "description": "在下方更新您的個人資料",
      "completeTitle": "完成您的個人資料",
      "completeDescription": "請填寫您的個人資料以開始使用",
      "firstName": "名字",
      "lastName": "姓氏",
      "email": "電子郵件",
      "whatsappNumber": "WhatsApp 號碼",
      "phoneNumber": "電話號碼",
      "required": "*",
      "whatsappPlaceholder": "例如：+852 1234 5678",
      "phonePlaceholder": "例如：+852 1234 5678",
      "whatsappDescription": "您的 WhatsApp 號碼供客戶聯繫",
      "phoneDescription": "備用電話號碼（可選）",
      "whatsappVerified": "已驗證",
      "saving": "儲存中...",
      "save": "儲存變更",
      "complete": "完成個人資料"
    },
    "security": {
      "title": "安全設定",
      "description": "更新您的密碼和安全偏好",
      "currentPassword": "目前密碼",
      "newPassword": "新密碼",
      "confirmPassword": "確認新密碼",
      "passwordPlaceholder": "輸入您的密碼",
      "passwordRequirement": "密碼至少需要8個字元",
      "updating": "更新中...",
      "update": "更新密碼",
      "error": "錯誤",
      "success": "密碼更新成功"
    }
  },
  "listings": {
    "title": "我的列表",
    "description": "管理和查看您的服務列表",
    "loading": "載入列表中...",
    "addNewListing": "新增列表",
    "empty": {
      "noListings": "未找到列表",
      "noListingsDescription": "您尚未創建任何列表。創建您的第一個列表以開始吸引客戶。",
      "noFilteredListings": "所選狀態未找到列表",
      "addListingButton": "創建列表",
      "viewAllButton": "查看所有列表"
    },
    "filters": {
      "all": "所有狀態",
      "pending": "待審核",
      "approved": "已啟用",
      "rejected": "已拒絕"
    },
    "alerts": {
      "freeTierTitle": "免費方案限制",
      "freeTierDescription": "您目前使用免費方案，只允許一個啟用的列表。",
      "additionalListingsRejected": "額外的列表將自動被拒絕。",
      "upgradePrompt": "升級到高級方案以創建無限列表。",
      "upgradeButton": "升級到高級方案"
    }
  },
  "favorites": {
    "title": "我的收藏",
    "description": "您已保存的服務提供者",
    "loading": "載入收藏中...",
    "searchPlaceholder": "搜索您的收藏...",
    "providerCount": "顯示 {{count}} 個{{provider}}",
    "provider_one": "提供者",
    "provider_other": "提供者",
    "noFavorites": {
      "title": "尚無收藏",
      "description": "保存您感興趣的服務提供者以在此處查看",
      "button": "瀏覽服務"
    },
    "noSearchResults": {
      "title": "無搜索結果",
      "description": "嘗試調整您的搜索詞或清除搜索以查看所有收藏",
      "button": "清除搜索"
    }
  },
  "contact": {
    "providerWhatsappInquiryMessage": "你好，我在 WhatsGood HK 平台上看到了 {{serviceName}}。"
  },
  "footer": {
    "description": "與香港值得信賴的服務提供者聯繫",
    "quickLinks": "快速連結",
    "legal": "法律",
    "contact": "聯繫",
    "followUs": "關注我們",
    "copyright": "© 2025 WhatsGood HK.",
    "about": "關於",
    "aboutDescription": "與香港值得信賴的服務提供者聯繫",
    "home": "首頁",
    "browseServices": "瀏覽服務",
    "listYourService": "刊登您的服務",
    "aboutUs": "關於我們",
    "pricing": "價格方案",
    "privacyPolicy": "隱私政策",
    "termsOfService": "服務條款",
    "getInTouch": "聯繫我們",
    "getInTouchDescription": "有問題或需要幫助？我們在這裡為您提供協助。",
    "contactUs": "聯繫我們",
    "loadingContact": "載入聯繫方式...",
    "whatsappUs": "WhatsApp 聯繫",
    "whatsappInquiryMessage": "你好，我想查詢有關 WhatsGood HK 及本網站的資訊。",
    "shareViaWhatsapp": "透過 WhatsApp 分享"
  }
}
